import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '@environments/environment';
import { NetworkStatusService } from '@services/network-status.service';
import { ErrorService } from '@services/error.service';
@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
})
export class AppComponent {
	/** Show side nav toggle */
	networkStatus = true;
	/** Alive flag */
	alive = true;
	/**show Error flag*/
	showError = false;
	/** constructor */
	constructor(
		private router: Router,
		public networkStatusSR: NetworkStatusService,
		private errSr: ErrorService
	) {
		this.networkStatus = this.networkStatusSR.getNetworkStatus();
		document.body.classList.add('theme-dark');
		if (!environment.LOG_CONFIGS.enableLogs) {
			console.log = function () {};
			console.warn = function () {};
		}
		if (!environment.LOG_CONFIGS.enableErrorLogs) {
			console.error = function () {};
			console.trace = function () {};
		}
		if (!environment.LOG_CONFIGS.enableInfoLogs) {
			console.info = function () {};
		}

		this.networkStatusSR.checkConnection.pipe().subscribe(() => {
			this.networkStatus = this.networkStatusSR.networkStatus;
			if (!this.networkStatusSR.networkStatus) {
				document.body.classList.add('offlineApp');
			} else if (document.body.classList.contains('offlineApp')) {
				document.body.classList.remove('offlineApp');
				window.location.reload();
			}
		});

		this.errSr.checkForError.subscribe((bol: boolean) => {
			this.showError = bol;
		});
	}
}
